/**
 * 设备广告相关接口地址：http://rap2.10niu.cn/repository/editor?id=21&mod=670&itf=4368
 */

import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const equipmentAdvert = {
	// 广告_添加
	addAds(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/ads/add`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 广告_编辑
	editAds(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/ads/edit`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 广告_删除
	delAds(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/ads/del`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 广告_开关
	openAds(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/ads/open`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 广告_列表
	getAdsList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/ads/list`,
			headers: config.headers,
			params
		});
	},
	// 行政区域_获取全部行政区域
	getAcquisitionProvince(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/administrative-division/all-list`,
			headers: config.headers,
			params
		});
	},
	// 行政区域_根据地区获取学校列表
	getSchoolsByDistrict(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/administrative-division/schools-by-district`,
			headers: config.headers,
			params
		});
	}
};

export default equipmentAdvert;
